import React from "react";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import get from "lodash/get";

import "./social-media-share.m.css";

const SOCIAL_MEDIA_SHARE = [
  {
    name: "whatsapp",
    type: "whatsappicon",
    icon: (
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="25.5" height="25.5" rx="4.25" stroke="#DDDDDD" strokeWidth="1.5" />
        <path
          d="M5.625 21.3754L6.73738 17.3309C6.05096 16.147 5.69028 14.805 5.69094 13.4288C5.69292 9.12646 9.21072 5.62537 13.533 5.62537C15.6305 5.62602 17.5994 6.43912 19.0803 7.91437C20.5607 9.38962 21.3757 11.3505 21.375 13.4361C21.373 17.7391 17.8552 21.2402 13.533 21.2402C12.2208 21.2395 10.9278 20.9121 9.7824 20.2899L5.625 21.3754ZM9.97494 18.877C11.0801 19.53 12.1351 19.9211 13.5303 19.9218C17.1226 19.9218 20.049 17.012 20.051 13.4347C20.0523 9.8503 17.1398 6.94443 13.5356 6.94312C9.94066 6.94312 7.0163 9.85293 7.01498 13.4295C7.01432 14.8896 7.44424 15.983 8.16626 17.1268L7.50754 19.5208L9.97494 18.877ZM17.4833 15.2913C17.4345 15.2099 17.304 15.1613 17.1075 15.0636C16.9116 14.9658 15.9483 14.4939 15.7683 14.429C15.5889 14.364 15.4584 14.3312 15.3271 14.5267C15.1966 14.7216 14.8207 15.1613 14.7067 15.2913C14.5926 15.4212 14.4779 15.4376 14.282 15.3398C14.0862 15.2421 13.4545 15.0366 12.7061 14.3719C12.1239 13.8547 11.7302 13.2162 11.6161 13.0206C11.5021 12.8257 11.6043 12.7201 11.7019 12.623C11.7902 12.5357 11.8977 12.3952 11.9959 12.2811C12.0955 12.1682 12.1278 12.0868 12.1938 11.9562C12.259 11.8263 12.2267 11.7121 12.1773 11.6143C12.1278 11.5172 11.7362 10.5571 11.5733 10.1666C11.4137 9.78665 11.2522 9.83783 11.1322 9.83193L10.7563 9.82537C10.6258 9.82537 10.4134 9.87393 10.2341 10.0695C10.0547 10.2651 9.54832 10.7362 9.54832 11.6963C9.54832 12.6564 10.2506 13.5837 10.3482 13.7136C10.4464 13.8436 11.7296 15.8136 13.6952 16.6582C14.1627 16.8591 14.528 16.9791 14.8122 17.0691C15.2816 17.2174 15.7089 17.1964 16.0465 17.1465C16.423 17.0907 17.2057 16.6746 17.3693 16.2192C17.5328 15.7631 17.5328 15.3726 17.4833 15.2913Z"
          fill="#25D366"
        />
      </svg>
    )
  },
  {
    name: "facebook",
    type: "facebookicon",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="26.5" height="26.5" rx="4.25" stroke="#DDDDDD" strokeWidth="1.5" />
        <path
          d="M17.4997 11.5497H14.7645V9.91638C14.7645 9.07358 14.8297 8.54275 15.9773 8.54275H17.4267V5.94576C16.7214 5.86899 16.0122 5.83143 15.3022 5.83306C13.1971 5.83306 11.6608 7.18627 11.6608 9.67056V11.5497H9.33301V14.8164L11.6608 14.8155V22.1663H14.7645V14.8139L17.1435 14.8131L17.4997 11.5497Z"
          fill="#3B5998"
        />
      </svg>
    )
  },
  {
    name: "twitter",
    type: "twittericon",
    icon: (
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="25.5" height="25.5" rx="4.25" stroke="#DDDDDD" strokeWidth="1.5" />
        <path
          d="M18.2447 5.92792H20.7748L15.2473 12.2455L21.75 20.8424H16.6584L12.6705 15.6284L8.10746 20.8424H5.57582L11.4881 14.085L5.25 5.92792H10.4708L14.0755 10.6937L18.2447 5.92792ZM17.3567 19.328H18.7587L9.70905 7.36277H8.2046L17.3567 19.328Z"
          fill="#232323"
        />
      </svg>
    )
  },

  {
    name: "linkedin",
    type: "linkedinicon",
    icon: (
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="25.5" height="25.5" rx="4.25" stroke="#DDDDDD" strokeWidth="1.5" />
        <path
          d="M7 8.00275C7 7.44887 7.46025 7 8.02813 7H19.9719C20.5398 7 21 7.44887 21 8.00275V19.9972C21 20.5511 20.5398 21 19.9719 21H8.02813C7.46025 21 7 20.5511 7 19.9972V8.00275ZM11.3251 18.7197V12.3979H9.22425V18.7197H11.3251ZM10.2751 11.5343C11.0075 11.5343 11.4634 11.0495 11.4634 10.4423C11.4502 9.82188 11.0084 9.35025 10.2891 9.35025C9.56988 9.35025 9.1 9.82275 9.1 10.4423C9.1 11.0495 9.55588 11.5343 10.2611 11.5343H10.2751ZM14.5696 18.7197V15.1891C14.5696 15.0001 14.5836 14.8111 14.6396 14.6764C14.791 14.2993 15.1366 13.9081 15.7176 13.9081C16.478 13.9081 16.7816 14.4874 16.7816 15.3379V18.7197H18.8825V15.0938C18.8825 13.1512 17.8465 12.2483 16.464 12.2483C15.3492 12.2483 14.8496 12.8607 14.5696 13.2921V13.314H14.5556L14.5696 13.2921V12.3979H12.4696C12.4959 12.9911 12.4696 18.7197 12.4696 18.7197H14.5696Z"
          fill="#0077B5"
        />
      </svg>
    )
  },
  {
    name: "telegram",
    type: "telegramicon",
    icon: (
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="25.5" height="25.5" rx="4.25" stroke="#DDDDDD" strokeWidth="1.5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.484 9.74836C13.1741 10.3046 10.5563 11.456 6.63039 13.2024C5.99289 13.4612 5.65894 13.7144 5.62854 13.962C5.57716 14.3805 6.09039 14.5452 6.78927 14.7696C6.88434 14.8001 6.98284 14.8318 7.08383 14.8653C7.77142 15.0935 8.69636 15.3605 9.17719 15.3711C9.61336 15.3807 10.1002 15.1971 10.6376 14.8203C14.3057 12.2922 16.1991 11.0144 16.318 10.9868C16.4019 10.9674 16.5181 10.943 16.5968 11.0144C16.6756 11.0859 16.6678 11.2212 16.6595 11.2575C16.6087 11.4788 14.594 13.3912 13.5515 14.3808C13.2265 14.6893 12.9959 14.9082 12.9488 14.9581C12.8432 15.0701 12.7356 15.176 12.6322 15.2778C11.9934 15.9065 11.5144 16.378 12.6587 17.148C13.2087 17.518 13.6487 17.824 14.0877 18.1292C14.5672 18.4626 15.0454 18.7951 15.6641 19.2092C15.8217 19.3147 15.9723 19.4243 16.1189 19.531C16.6769 19.9372 17.1781 20.3021 17.7974 20.2439C18.1573 20.2101 18.529 19.8646 18.7178 18.8342C19.1639 16.399 20.0408 11.1228 20.2435 8.94862C20.2613 8.75813 20.2389 8.51434 20.221 8.40733C20.203 8.30031 20.1656 8.14783 20.0293 8.03496C19.868 7.90128 19.6189 7.87309 19.5075 7.8751C19.001 7.88421 18.2238 8.1601 14.484 9.74836Z"
          fill="#0088CC"
        />
      </svg>
    )
  },
  {
    name: "mail",
    type: "mailicon",
    icon: (
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="25.5" height="25.5" rx="4.25" stroke="#DDDDDD" strokeWidth="1.5" />
        <path
          d="M6.7 21C6.2325 21 5.83229 20.8286 5.49938 20.4859C5.16646 20.1432 5 19.7312 5 19.25V8.75C5 8.26875 5.16646 7.85677 5.49938 7.51406C5.83229 7.17135 6.2325 7 6.7 7H20.3C20.7675 7 21.1677 7.17135 21.5006 7.51406C21.8335 7.85677 22 8.26875 22 8.75V19.25C22 19.7312 21.8335 20.1432 21.5006 20.4859C21.1677 20.8286 20.7675 21 20.3 21H6.7ZM13.5 14.875L6.7 10.5V19.25H20.3V10.5L13.5 14.875ZM13.5 13.125L20.3 8.75H6.7L13.5 13.125ZM6.7 10.5V8.75V19.25V10.5Z"
          fill="#333333"
        />
      </svg>
    )
  }
];

const socialMediaUrl = (type, headline, publishedURL) => {
  const encodedHeadline = encodeURIComponent(headline);
  let url;

  switch (type) {
    case "facebook":
      url = `http://en-gb.facebook.com/sharer/sharer.php?utm_source=deccanherald&utm_medium=facebook&u=${encodeURIComponent(
        publishedURL + "?utm_source=facebook&utm_medium=referral&utm_campaign=socialshare"
      )}&t=${encodedHeadline}`;
      break;
    case "twitter":
      url = `https://twitter.com/intent/tweet?utm_source=deccanherald&utm_medium=twitter&url=${encodeURIComponent(
        publishedURL + "?utm_source=twitter&utm_medium=referral&utm_campaign=socialshare"
      )}&text=${encodedHeadline}&via=deccanherald`;
      break;
    case "whatsapp":
      url = `https://api.whatsapp.com/send?utm_source=deccanherald&utm_medium=whatsapp&text=${encodedHeadline} ${encodeURIComponent(
        publishedURL + "?utm_source=whatsapp&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "linkedin":
      url = `http://www.linkedin.com/shareArticle?utm_source=deccanherald&utm_medium=linkedin&mini=true&title=${encodedHeadline}
      &url=${encodeURIComponent(publishedURL + "?utm_source=linkedin&utm_medium=referral&utm_campaign=socialshare")}`;
      break;
    case "telegram":
      url = `https://t.me/share/url?utm_source=deccanherald&utm_medium=telegram&url=${encodeURIComponent(
        publishedURL + "?utm_source=telegram&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    case "mail":
      url = `mailto:?subject=${encodedHeadline}&body=${encodedHeadline}:%20${encodeURIComponent(
        publishedURL + "?utm_source=mail&utm_medium=referral&utm_campaign=socialshare"
      )}`;
      break;
    default:
      url = "";
      break;
  }
  return url;
};

const SocialMediaShare = ({ story, isAmpStory = false }) => {
  const { headline, url } = story;
  const altSocialHeadline = get(story, ["alternative", "social", "default", "headline"], headline);

  return (
    <div className="social-wrapper" styleName="social-wrapper">
      <div styleName="triangle"></div>
      {SOCIAL_MEDIA_SHARE.map((share, index) => (
        <a
          key={index}
          target="_blank"
          rel="nofollow noreferrer"
          href={socialMediaUrl(share.name, altSocialHeadline, url)}
        >
          {isAmpStory ? share.icon : <SvgIconHandler type={share.type} />}
        </a>
      ))}
    </div>
  );
};

export default SocialMediaShare;
